import { color } from "../../../../constant/color";
import Button from "../../../Button";
import CloseIcon from "../../../CloseIcon";
import React, { useEffect, useState } from "react";
import "./style.css";
import toast from "react-hot-toast";
import axios from "../../../../utils/axios";
import { Select } from "antd";
import { meterController } from "../../../../Controller/meterController";
import { useForm } from "react-hook-form";
import {
  useAddMeterToDCUMutation,
  useCreateDCUMutation,
} from "../../../../services/device.services";
import { CustomButton } from "../../../CustomButton";
import ErrorText from "../../../Errors/ErrorText";
import { errorBlock } from "../../../../Controller/errorBlock";
import { deviceController } from "../../../../Controller/deviceController";
import { useParams } from "react-router-dom";

const AddMeterToDCU = ({ closeBtn, refreshBtn }) => {
  const { Option } = Select;
  const [serialid, setSerialid] = useState("");
  const [meterid, setMeterid] = useState("");
  const [company, setcompany] = useState([]);
  const [alias, setalias] = useState("");
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [addMeterToDCU, { isLoading, error, status }] =
    useAddMeterToDCUMutation();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const handleSubmeter = async (data) => {
    try {
      if (!alias) return toast.error("Please select a company to continue.");
      // closeBtn(false);
      let res = await addMeterToDCU({ ...data, dcuid: id, alias }).unwrap();
      const result = deviceController(res);

      if (result.type != "success") {
        toast.error("Failed to assign meter to DCU.");
        return;
      }
      refreshBtn((prev) => !prev);
      closeBtn(false);
      toast.success("Meter assigned to DCU successfully.");
    } catch (err) {
      console.log(err, "error");
      errorBlock(err);
    }
  };

  // console.log(status, "erer");

  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post(`/management/getallcompanydata`, {});

        let result = meterController(res);
        if (result.message !== "success") {
          toast.error(result.message);
        }

        setcompany(result.data.body);
      } catch (err) {
        toast.error(err.message);
      }
    })();
  }, []);

  return (
    <div className="backdrop">
      <div className="submeter-add_modal animate__animated animate__fadeInUp bg-white rounded-3">
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between">
            <div className="pt-2 pb-2 ">Fill form to assign a meter to DCU</div>
            <div>
              <div className="" onClick={() => closeBtn(false)}>
                <CloseIcon />
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <form onSubmit={handleSubmit(handleSubmeter)} className="col-12">
              <div class="mb-3 company-entry">
                <input
                  type="text"
                  class="form-control"
                  {...register("meterid", {
                    required: true,
                  })}
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength) {
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    }
                  }}
                  maxLength="15"
                  placeholder="Enter meter number"
                />
                {errors.meterid && <ErrorText text={"Field is required"} />}
              </div>

              <div class="mb-3 company-entry">
                <div className="w-100">
                  <Select
                    showSearch
                    className="form-input w-100"
                    placeholder={"Select a company"}
                    onChange={(e) => setalias(e)}
                    size="large"
                  >
                    {company.map((i) => (
                      <Option key={i} value={i.companyalias}>
                        {i.companyname}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="my-4">
                <CustomButton
                  loading={isLoading}
                  className={
                    "w-100 border-none outline-none border-0 bg-primary text-white p-2 rounded"
                  }
                  styles={{
                    background: color.primary,
                  }}
                >
                  <p
                    className="m-0"
                    style={{
                      fontSize: 15,
                    }}
                  >
                    Create DCU
                  </p>
                </CustomButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMeterToDCU;
